import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import conf from 'conf/conf';
import { useModal } from 'context/ModalContext';
import { useSettings } from 'context/SettingsContext';
import NeedPay from '../NeedPay';
import { getTariffRestriction } from '../helper/getTariffRestriction';

const useNeedPay = () => {
    const { showDlg, hideDlg } = useModal();
    const { settings } = useSettings();
    const { t } = useTranslation('Tariff');
    const navigate = useNavigate();

    const needPay = (): boolean => {
        if (!conf.saasMode) return false;
        const restriction = getTariffRestriction(settings);
        if (!restriction) return false;

        showDlg({
            type: 'info',
            title: t(restriction === 'objectLimit' ? 'objectLimitTitle' : 'needPayTitle'),
            text: <NeedPay objectLimit={restriction === 'objectLimit'} />,
            buttons: [
                {
                    title: t('needPayAction'),
                    variant: 'primary',
                    handleClick: () => {
                        hideDlg();
                        navigate('/tariff');
                    },
                },
            ],
        });

        return true;
    };

    return { needPay };
};

export default useNeedPay;
